import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import GameCard from './GameCard';
import Game from './Game';

const games = [
  {
    id: 'bus',
    path: '/drive-my-bus',
    title: 'Drive My Bus',
    description: 'Drive through the city and pick up passengers safely!',
    imageUrl: '/images/bus-game.jpg',
  },
  {
    id: 'tractor',
    path: '/drive-my-tractor',
    title: 'Drive My Tractor',
    description: 'Help farmers by driving your tractor through fields!',
    imageUrl: '/images/tractor-game.jpg',
  },
  {
    id: 'forklift',
    path: '/drive-my-forklift',
    title: 'Drive My Forklift',
    description: 'Operate a forklift in a warehouse environment!',
    imageUrl: '/images/forklift-game.jpg',
  },
  // Thêm các phương tiện mới
  {
    id: 'monstertruck',
    path: '/drive-my-monster-truck',
    title: 'Drive My Monster Truck',
    description: 'Drive a powerful monster truck over obstacles!',
    imageUrl: '/images/monster-truck-game.jpg',
  },
  {
    id: 'pickuptruck',
    path: '/drive-my-pickup-truck',
    title: 'Drive My Pickup Truck',
    description: 'Transport goods with your pickup truck!',
    imageUrl: '/images/pickup-truck-game.jpg',
  },
  {
    id: 'policecar',
    path: '/drive-my-police-car',
    title: 'Drive My Police Car',
    description: 'Chase bad guys in your police car!',
    imageUrl: '/images/police-car-game.jpg',
  },
  {
    id: 'firetruck',
    path: '/drive-my-firetruck',
    title: 'Drive My Fire Truck',
    description: 'Rush to put out fires with your fire truck!',
    imageUrl: '/images/firetruck-game.jpg',
  },
  {
    id: 'ambulance',
    path: '/drive-my-ambulance',
    title: 'Drive My Ambulance',
    description: 'Save lives by driving patients to the hospital!',
    imageUrl: '/images/ambulance-game.jpg',
  },
  {
    id: 'garbagetruck',
    path: '/drive-my-garbage-truck',
    title: 'Drive My Garbage Truck',
    description: 'Keep the city clean with your garbage truck!',
    imageUrl: '/images/garbage-truck-game.jpg',
  },
  {
    id: 'bulldozer',
    path: '/drive-my-bulldozer',
    title: 'Drive My Bulldozer',
    description: 'Clear paths and move earth with your bulldozer!',
    imageUrl: '/images/bulldozer-game.jpg',
  },
  {
    id: 'roadroller',
    path: '/drive-my-roadroller',
    title: 'Drive My Road Roller',
    description: 'Flatten and smooth roads with your road roller!',
    imageUrl: '/images/roadroller-game.jpg',
  },
  {
    id: 'excavator',
    path: '/drive-my-excavator',
    title: 'Drive My Excavator',
    description: 'Dig and move earth with your powerful excavator!',
    imageUrl: '/images/excavator-game.jpg',
  },
  {
    id: 'tank',
    path: '/drive-my-tank',
    title: 'Drive My Tank',
    description: 'Command a mighty tank through challenging terrain!',
    imageUrl: '/images/tank-game.jpg',
  },
];

const GameGrid: React.FC = () => {
  const [selectedGame, setSelectedGame] = useState<string | null>(null);

  if (selectedGame) {
    return <Game gameId={selectedGame} onBack={() => setSelectedGame(null)} />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-5xl font-display font-bold text-white text-center mb-8 drop-shadow-lg">
      <svg width="300" height="150" viewBox="0 0 300 150" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Bangers&display=swap');
        </style>
    </defs>
    <rect width="100%" height="100%" fill="transparent"/>
    
    <text x="50%" y="90" font-family="'Bangers', sans-serif" font-size="60" font-weight="bold" text-anchor="middle">
        <tspan fill="#F9B233">E</tspan>
        <tspan fill="#6441A5">N</tspan>
        <tspan fill="#E8193C">K</tspan>
        <tspan fill="#6FCF97">L</tspan>
        <tspan fill="#F9B233">E</tspan>
        <tspan fill="#27A9E1">S</tspan>
        <tspan fill="#E8193C">P</tspan>
        <tspan fill="#6FCF97">I</tspan>
        <tspan fill="#6441A5">L</tspan>
        <tspan fill="#F9B233">L</tspan>
        <tspan font-size="20" fill="#333">.no</tspan>
    </text>
</svg>
      </h1>
      <h2 className='text-3xl font-display font-bold text-white text-center mb-8 drop-shadow-lg'>🌟 Enklespill – Enkle og morsomme spill for barn fra 2 til 7 år!</h2>
      <h2 className="text-1xl font-display font-bold text-white text-center mb-8 drop-shadow-lg">
      Vi lager enkle og rolige spill som hjelper barn med å leke og utforske verden rundt seg. Med et brukervennlig grensesnitt, intuitive visuelle elementer og kjente kjøretøy som barn elsker, er Enklespill et sted hvor barna kan ha det gøy uten å trenge kompliserte instruksjoner fra voksne.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {games.map((game) => (
          <Link key={game.id} to={game.path} className="transform hover:scale-105 transition-transform">
            <GameCard
              title={game.title}
              description={game.description}
              imageUrl={game.imageUrl}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default GameGrid;